import lpApp from '../lp_app';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/ovc.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpOpsOVC {
  getIndexOfMultiple(multiple) {
    const muls = lpApp.indexes.multiples.multiples;
    let index = -1;
    Object.keys(muls).forEach((idx) => {
      // console.log(muls[idx])
      for (let i = 0; i < muls[idx].length; i += 1) {
        if (muls[idx][i] === multiple) index = i;
      }
    });
    return index + 1;
  }

  /*  initParentingVars() {
      const varsParents = {};
      // extract the variable to option thing =
      Object.keys(lpApp.references.options).map((idx) => {
        lpApp.references.getOption(idx).variables.map((jdx) => {
          varsParents[jdx] = idx;
        });
      });
      return varsParents;
    } */


  // __ES_LINT_IVANN__ commented these two unused methods
  /*  initParentingOpts() {
      const optsParents = {};
      // debugger;
      // extract the variable to option thing =
      Object.keys(lpApp.references.options).map((idx) => {
        lpApp.references.getOption(idx).children.map((jdx) => {
          optsParents[jdx] = idx;
        });
      });
      return optsParents;
    } */
  /*

    fromOVC() {
      // console.log(result);
      const on_opts = {};
      const result = {
        o: lpApp.getState().loadedOvc.o,
        v: lpApp.getState().loadedOvc.v,
        c: lpApp.getState().loadedOvc.c,
      };
      const ops_par = this.initParentingOpts();
      const var_par = this.initParentingVars();


      const options_flat = {};
      let opts = result.o;
      if ((typeof opts === 'undefined') || (opts.length)) opts = {};
      const opts_keys = Object.keys(opts);

      let i = 0;
      for (; i < opts_keys.length; i += 1) {
        const idx = opts_keys[i];
        const now_ = opts[idx];
        if ((typeof now_ === 'object') && (now_.length > 1)) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (jdx == '') {
              // console.log("faragh")
            } else if (j == 0) {
              // the first option
              options_flat[jdx] = true;
              options_flat[idx] = true;
            } else {
              let k = generateId1(4);
              if (lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx))) {
                const m_ = lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx));
                if ((i - 1) > m_.length) {
                  lpApp.indexes.multiples.getMultiple(getFirstMultipleParent(idx)).push(k);
                  options_flat[`${idx}_${k}`] = true;
                  options_flat[`${jdx}_${k}`] = true;
                } else {
                  k = m_[i - 1];
                  options_flat[`${idx}_${k}`] = true;
                  options_flat[`${jdx}_${k}`] = true;
                }
              } else {
                lpApp.indexes.multiples.addMultiple(idx, [k]);

                options_flat[`${idx}_${k}`] = true;
                options_flat[`${jdx}_${k}`] = true;
              }

              // window.lp_mult[idx] = true;
            }
          }
        } else if (now_ == '');
        // console.log("faragh");
        else options_flat[now_] = true;
      }

      // checkbox flat
      const checkbox_flat = {};
      let chk = result.c;
      if ((typeof chk === 'undefined') || (chk.length)) chk = {};
      const chk_keys = Object.keys(chk);
      i = 0;

      for (i = 0; i < chk_keys.length; i += 1) {
        const idx = chk_keys[i];
        const now_ = chk[idx].c ? chk[idx].c : chk[idx];
        let now_opts = chk[idx].v;

        if ((now_ != null) && now_ && (typeof now_ === 'object') && now_.length > 1) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (j == 0) {
              checkbox_flat[idx] = jdx;
            } else {
              const mk = getOFirstMultipleParent(idx);
              if (mk) {
                if (typeof lpApp.indexes.multiples.getMultiple(mk) !== 'undefined') {
                checkbox_flat[`${idx}_${lpApp.indexes.multiples.getMultiple(mk)[j - 1]}`] = jdx;
                }

                // debugger;
              }
            }
          }
        } else {
          checkbox_flat[idx] = typeof now_ === 'object' ? now_[0] : now_;
        }

        if ((typeof now_opts === 'object') && typeof now_opts.length === 'undefined') {
          const c_opts = now_opts;
          now_opts = [];
          for (const i in c_opts) {
            now_opts.push(c_opts[i]);
          }
        }
        if ((typeof now_opts === 'object') && (now_opts.length > 1)) {
          for (let j = 0; j < now_opts.length; j += 1) {
            const jdx = now_opts[j];
            // console.log(idx+ ' : '+jdx);
            if (jdx == '') {
              // console.log("faragh")
            } else if (j == 0) {
              // the first option
              options_flat[jdx] = true;
            } else {
              const k = generateId1(4);

              if (lpApp.indexes.multiples.getMultiple(idx)) {
                const tmp = lpApp.indexes.multiples.getMultiple(idx);
                tmp.push(k);
                lpApp.indexes.multiples.addMultiple(idx, tmp);
              } else lpApp.indexes.multiples.addMultiple(idx, [k]);
              options_flat[`${jdx}_${k}`] = true;
            }
          }
        } else if (now_opts == '');
        // console.log("faragh");
        else options_flat[now_opts] = true;
      }
      // console.log("hello")
      // extract informaion from V
      // don't waste variables xD hahahahha
      const vars_flat = {};
      i = 0;
      const v_keys = Object.keys(result.v);
      const v_ = result.v;
      for (i = 0; i < v_keys.length; i += 1) {
        const idx = v_keys[i];
        const now_ = v_[idx];
        if (typeof now_ === 'object' && now_.length > 1) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (j == 0) {
              vars_flat[idx] = jdx;
            } else {
              const mk = getFirstMultipleParent(idx);
              if (typeof mk !== 'undefined') {
                // debugger;
                if (typeof lpApp.indexes.multiples.getMultiple(mk) !== 'undefined') {
                vars_flat[`${idx}_${lpApp.indexes.multiples.getMultiple(mk)[j - 1]}`] = jdx;
                }
              }
            }
          }
        } else {
          vars_flat[idx] = typeof now_ === 'object' ? now_[0] : now_;
        }
      }
      return {
        o_c: options_flat,
        v_c: vars_flat,
        c_c: checkbox_flat,
      };
    }
  */

  multipleFirst(id) {
    // if(typeof id == 'undefined'){
    //     console.trace("varioable undefined");
    //     debugger;
    // }
    let now = id; // parseInt(id);
    while (typeof now !== 'undefined') {
      if (lpApp.references.getOption(now).meta.multiple) return now;
      now = lpApp.indexes.grandpa.getFather(now);
    }
    return false;
  }


  /*  getMultiplePosition(id) {
      const pureId = lpIdGetPure(id);
      const copy = lpIdGetCopy(id);
      const multiples = lpApp.indexes.multiples.getMultiple(this.multipleFirst(pureId));
      if (typeof multiples === 'undefined') return false;
      let idx = 1;
      const i = 0;
      while (multiples[i] !== copy) {
        idx += 1;
      }
      return idx;
    } */

  /*  toOVC() {
      const options = lpApp.getState().output.o;
      const variables = lpApp.getState().output.v;
      const options_pre = lpApp.getState().loadedOvc.oF;
      const checkbox_pre = lpApp.getState().loadedOvc.cF;
      const variables_pre = lpApp.getState().loadedOvc.vF;

      const o = {};
      const c = {};
      const v = {};

      // TODO: get the nearest grandpa multiple
      // initialization of options

      if (options_pre) {
        Object.keys(options_pre).map((idx) => {
          if (idx == true && lpApp.indexes.grandpa.getFather(lpIdGetPure(idx))) {
          // debugger
            if (lpIdGetCopy(idx) != -2) { // multiple thing
              const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx));
              o[par].push(lpIdGetPure(idx));
            } else if (
            lpApp.references.getOption(lpApp.indexes.grandpa.getFather(idx)).meta.multiple
            ) {
              o[lpApp.indexes.grandpa.getFather(idx)] = [idx];
            } else o[lpApp.indexes.grandpa.getFather(idx)] = idx;
          }
        });
      }


      // console.log(checkbox_pre)
      if (checkbox_pre) {
        Object.keys(checkbox_pre).map((idx) => {
        // console.log(idx)
          if (lpIdGetCopy(idx) == -2) { // multiple thing
            c[lpIdGetPure(idx)].push(checkbox_pre[idx]);
          } else if (lpApp.indexes.grandpa.getFather(idx) in lpApp.references.options
          && lpApp.references.getOption(lpApp.indexes.grandpa.getFather(idx)).meta.multiple
          ) {
            c[lpIdGetPure(idx)] = [checkbox_pre[lpIdGetPure(idx)]];
          } else c[lpIdGetPure(idx)] = checkbox_pre[lpIdGetPure(idx)];
        });
      }


      // initialization from checkboxes
      options.map((idx) => {
        if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type == 'radio') {
          if (idx.value == true && lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id))) {
          // debugger
            if (lpIdGetCopy(idx.id) != -2) { // multiple thing
              const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
              if (typeof o[par] !== 'object') {
                o[par] = [];
                const max_ = this.getMultiplePosition(idx.id);
                for (let idx = 0; idx < max_; idx += 1) o[par].push('');
              }
              o[par].push(lpIdGetPure(idx.id));
            } else if (this.multipleFirst(lpIdGetPure(idx.id))) {
              o[lpApp.indexes.grandpa.getFather(idx.id)] = [idx.id];
            } else o[lpApp.indexes.grandpa.getFather(idx.id)] = idx.id;
          }
        }
        if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type == 'checkbox') {
          // debugger
          if (lpIdGetCopy(idx.id) != -2) { // multiple thing
            const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
            if (typeof c[lpIdGetPure(idx.id)] !== 'object') {
              c[lpIdGetPure(idx.id)] = [];
              const max_ = this.getMultiplePosition(idx.id);
              for (let i = 0; i < max_; i += 1) {
                c[lpIdGetPure(idx.id)].push('');
              }
            }
            c[lpIdGetPure(idx.id)].push(idx.value);
            // console.log(idx.id)
            // console.log(c[lpIdGetPure(idx.id)])
          } else if (this.multipleFirst(lpIdGetPure(idx.id))) {
            if (typeof c[lpIdGetPure(idx.id)] === 'object') c[lpIdGetPure(idx.id)][0] = idx.value;
            else c[lpIdGetPure(idx.id)] = [idx.value];
          } else c[lpIdGetPure(idx.id)] = idx.value;
        }
      });
      if (variables_pre) {
        Object.keys(variables_pre).map((idx) => {
          if (lpIdGetCopy(idx) == -2) { // multiple thing
            v[lpIdGetPure(idx)].push(variables_pre[idx]);
          } else if (
          this.multipleFirst((lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(idx)))
          )) {
            v[lpIdGetPure(idx)] = [variables_pre[lpIdGetPure(idx)]];
          } else v[lpIdGetPure(idx)] = variables_pre[lpIdGetPure(idx)];
        });
      }

      variables.map((idx) => {
        // console.log(idx);
        if (lpIdGetCopy(idx.id) != -2) { // multiple thing
          const par = lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx.id));
          v[lpIdGetPure(idx.id)].push(idx.value);
        } else if (
        this.multipleFirst(
        (lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx.id))))
        )) {
          v[lpIdGetPure(idx.id)] = [idx.value];
        } else v[lpIdGetPure(idx.id)] = idx.value;
      });


      return {
        o,
        v,
        c,
      };
    } */
}


export default LpOpsOVC;



// WEBPACK FOOTER //
// ./src/app/ops/ovc.js